/**
 * ITEMCAT sub-environment (STG vs INT) selection, only meaningful when pubp
 * itself is running against "stg" (apiEnv === "stg") — see itemCatOrigin.ts.
 * Persisted to localStorage so the choice survives a page reload.
 */
export type ItemCatSubEnv = "STG" | "INT";

export const ITEM_CATALOG_SUB_ENV_KEY = "ITEM_CATALOG_SUB_ENV";

export const DEFAULT_ITEM_CATALOG_SUB_ENV: ItemCatSubEnv = "STG";

export const getStoredItemCatSubEnv = (): ItemCatSubEnv => {
  if (typeof window === "undefined") return DEFAULT_ITEM_CATALOG_SUB_ENV;
  const stored = window.localStorage.getItem(ITEM_CATALOG_SUB_ENV_KEY);
  return stored === "INT" ? "INT" : DEFAULT_ITEM_CATALOG_SUB_ENV;
};

export const storeItemCatSubEnv = (subEnv: ItemCatSubEnv): void => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ITEM_CATALOG_SUB_ENV_KEY, subEnv);
};

/**
 * Effective ITEMCAT environment id ("dev" | "stg" | "int" | "prd") for anything
 * that needs to be scoped per-env — e.g. per-env localStorage keys. stg and int
 * share one pubp host (see itemCatOrigin.ts header), so callers needing to tell
 * them apart must pass the live `itemCatSubEnv` (from AppContext) rather than
 * apiEnv alone. dev/prd are unaffected — they resolve to themselves.
 */
export const resolveEffectiveItemCatEnv = (apiEnv: string, subEnv: ItemCatSubEnv): string => {
  const env = apiEnv.toLowerCase();
  return env === "stg" ? subEnv.toLowerCase() : env;
};
